var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFavourites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 260,
    viewBox: "0 0 347 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_6517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.454 66.8301C242.887 66.8301 235.918 59.859 235.918 51.2901C235.918 42.7212 242.887 35.75 251.454 35.75C260.02 35.75 266.989 42.7211 266.989 51.2901C266.989 59.859 260.02 66.8301 251.454 66.8301ZM251.454 36.6825C243.401 36.6825 236.85 43.2354 236.85 51.2901C236.85 59.3447 243.401 65.8976 251.454 65.8976C259.506 65.8976 266.057 59.3447 266.057 51.2901C266.057 43.2354 259.506 36.6825 251.454 36.6825Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.269 57.6649L244.518 51.4597L245.965 49.8851L250.71 54.2473L255.957 44.7178L257.829 45.7491L251.269 57.6649Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82 90.0528H284.089C282.447 90.0528 281.11 88.7161 281.11 87.0729V83.0623C281.11 81.4191 282.447 80.082 284.089 80.082H300.82C302.463 80.082 303.799 81.4191 303.799 83.0623V87.0729C303.799 88.7161 302.463 90.0528 300.82 90.0528ZM284.089 80.7036C282.79 80.7036 281.732 81.7616 281.732 83.0621V87.0728C281.732 88.373 282.79 89.4311 284.089 89.4311H300.82C302.12 89.4311 303.178 88.373 303.178 87.0728V83.0621C303.178 81.7616 302.12 80.7036 300.82 80.7036H284.089Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.408 86.0822C287.973 85.8481 288.241 85.2002 288.007 84.635C287.773 84.0699 287.125 83.8015 286.56 84.0356C285.995 84.2697 285.727 84.9176 285.961 85.4828C286.195 86.0479 286.843 86.3163 287.408 86.0822Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.885 86.0822C293.45 85.8481 293.719 85.2002 293.485 84.635C293.251 84.0699 292.603 83.8015 292.038 84.0356C291.473 84.2697 291.205 84.9176 291.439 85.4828C291.673 86.0479 292.32 86.3163 292.885 86.0822Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.363 86.0822C298.928 85.8481 299.196 85.2002 298.962 84.635C298.728 84.0699 298.08 83.8015 297.515 84.0356C296.95 84.2697 296.682 84.9176 296.916 85.4828C297.15 86.0479 297.798 86.3163 298.363 86.0822Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1486 93.6078H21.4181C19.7754 93.6078 18.4387 92.2708 18.4387 90.6276V86.617C18.4387 84.9738 19.7754 83.6367 21.4181 83.6367H38.1486C39.7913 83.6367 41.1276 84.9738 41.1276 86.617V90.6276C41.1277 92.2709 39.7913 93.6078 38.1486 93.6078ZM21.4181 84.2584C20.118 84.2584 19.0602 85.3164 19.0602 86.617V90.6276C19.0602 91.9281 20.118 92.9862 21.4181 92.9862H38.1486C39.4485 92.9862 40.5062 91.9281 40.5062 90.6276V86.617C40.5062 85.3164 39.4485 84.2584 38.1486 84.2584H21.4181Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4015 88.7992C25.4994 88.1953 25.0895 87.6264 24.4859 87.5284C23.8822 87.4304 23.3134 87.8405 23.2155 88.4443C23.1175 89.0481 23.5274 89.617 24.1311 89.715C24.7347 89.813 25.3035 89.403 25.4015 88.7992Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8792 88.7992C30.9772 88.1953 30.5673 87.6264 29.9636 87.5284C29.36 87.4304 28.7912 87.8405 28.6933 88.4443C28.5953 89.0481 29.0052 89.617 29.6089 89.715C30.2125 89.813 30.7813 89.403 30.8792 88.7992Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3568 88.7992C36.4548 88.1953 36.0448 87.6264 35.4412 87.5284C34.8375 87.4304 34.2688 87.8405 34.1708 88.4443C34.0728 89.0481 34.4828 89.617 35.0864 89.715C35.6901 89.813 36.2588 89.403 36.3568 88.7992Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4205 197.263H24.3887V187.007H51.4205V197.263ZM25.0102 196.642H50.7991V187.628H25.0102V196.642Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4744 187.625H6.44263V177.369H33.4744V187.625ZM7.06398 187.003H32.853V177.99H7.06398V187.003Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.697 140.399H299.666V130.142H326.697V140.399ZM300.287 139.777H326.076V130.764H300.287V139.777Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.751 130.76H281.719V120.504H308.751V130.76ZM282.341 130.139H308.13V121.126H282.341V130.139Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.694 212.183H267.662V201.927H294.694V212.183ZM268.284 211.562H294.073V202.549H268.284V211.562Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.187 179.181C317.988 179.181 317.012 178.205 317.012 177.005C317.012 175.806 317.988 174.83 319.187 174.83C320.387 174.83 321.362 175.806 321.362 177.005C321.362 178.205 320.386 179.181 319.187 179.181ZM319.187 175.451C318.331 175.451 317.634 176.148 317.634 177.005C317.634 177.862 318.331 178.559 319.187 178.559C320.044 178.559 320.741 177.862 320.741 177.005C320.741 176.148 320.044 175.451 319.187 175.451Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15 61.084C194.95 61.084 193.975 60.108 193.975 58.9085C193.975 57.709 194.951 56.7329 196.15 56.7329C197.349 56.7329 198.324 57.7091 198.324 58.9085C198.324 60.1078 197.349 61.084 196.15 61.084ZM196.15 57.3544C195.293 57.3544 194.596 58.0516 194.596 58.9085C194.596 59.7653 195.293 60.4625 196.15 60.4625C197.006 60.4625 197.703 59.7653 197.703 58.9085C197.703 58.0516 197.007 57.3544 196.15 57.3544Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64221 151.83C0.443046 151.83 -0.532715 150.854 -0.532715 149.655C-0.532715 148.455 0.443176 147.479 1.64221 147.479C2.84124 147.479 3.81713 148.455 3.81713 149.655C3.81713 150.854 2.84137 151.83 1.64221 151.83ZM1.64221 148.1C0.785627 148.1 0.0886368 148.797 0.0886368 149.654C0.0886368 150.512 0.785627 151.208 1.64221 151.208C2.49879 151.208 3.19578 150.512 3.19578 149.654C3.19578 148.797 2.49879 148.1 1.64221 148.1Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.224 162.226H87.4304V243.524H193.224V162.226Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.226 162.226H150.137V243.524H193.226V162.226Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.616 193.772L123.674 191.803L120.489 193.772L116.838 190.171L113.032 193.772V162.226H125.616V193.772Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.793 80.9248H136.999V162.223H242.793V80.9248Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.928 80.9248H136.999V101.791H162.928V80.9248Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.843 97.2969H141.081V97.9185H158.843V97.2969Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.843 92.0664H141.081V92.6879H158.843V92.0664Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.795 80.9248H217.23V162.223H242.795V80.9248Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.08 112.471L195.138 110.502L191.953 112.471L188.303 108.87L184.496 112.471V80.9248H197.08V112.471Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.746 142.36H170.104V153.005H180.746V142.36Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.357 142.36H185.715V153.005H196.357V142.36Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.972 142.36H201.331V153.005H211.972V142.36Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.873 162.226H173.079V243.524H278.873V162.226Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M278.875 162.226H253.31V243.524H278.875V162.226Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.935 193.772L219.993 191.803L216.809 193.772L213.158 190.171L209.352 193.772V162.226H221.935V193.772Z",
    fill: "#1F3C88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_6517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 260,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavourites);
export default __webpack_public_path__ + "static/media/no-favourites.43a828d0eb8eb441c50b7d7c878805c7.svg";
export { ForwardRef as ReactComponent };